// extracted by mini-css-extract-plugin
module.exports = {"authenticationButton":"styles_authenticationButton__VbFhP","imgLabel__container":"styles_imgLabel__container__L4G_3"};